// src/data/templates.js
export const documentTemplates = [
  // === Professional Templates ===
  {
    id: 'thought-leadership',
    title: 'Thought Leadership Article',
    description: 'Research-backed article for industry publication or company blog.',
    icon: 'FileText',
    category: 'professional',
    documentType: 'article',
    tone: 'professional',
    targetAudience: 'general_professional',
    approach: 'balanced',
    targetWords: 2500,
  },
  {
    id: 'executive-white-paper',
    title: 'Executive White Paper',
    description: 'Comprehensive analysis with strategic recommendations for leadership.',
    icon: 'BookOpen',
    category: 'professional',
    documentType: 'white_paper',
    tone: 'executive',
    targetAudience: 'c_suite',
    approach: 'logical',
    targetWords: 5000,
  },
  {
    id: 'competitive-analysis',
    title: 'Competitive Analysis',
    description: 'Evidence-based comparison of market players and positioning.',
    icon: 'BarChart3',
    category: 'professional',
    documentType: 'competitive_analysis',
    tone: 'analytical',
    targetAudience: 'industry_peers',
    approach: 'logical',
    targetWords: 3000,
  },
  {
    id: 'market-brief',
    title: 'Market Brief',
    description: 'Concise market intelligence for executive decision-making.',
    icon: 'TrendingUp',
    category: 'professional',
    documentType: 'market_brief',
    tone: 'concise',
    targetAudience: 'c_suite',
    approach: 'logical',
    targetWords: 1500,
  },
  {
    id: 'case-study',
    title: 'Case Study',
    description: 'Problem-solution narrative backed by research evidence.',
    icon: 'Target',
    category: 'professional',
    documentType: 'case_study',
    tone: 'authoritative',
    targetAudience: 'general_professional',
    approach: 'balanced',
    targetWords: 3000,
  },
  {
    id: 'industry-brief',
    title: 'Industry Brief',
    description: 'Sector-specific research distilled into actionable intelligence.',
    icon: 'Globe',
    category: 'professional',
    documentType: 'industry_brief',
    tone: 'analytical',
    targetAudience: 'industry_peers',
    approach: 'logical',
    targetWords: 2000,
  },

  // === Academic Templates ===
  {
    id: 'academic-essay',
    title: 'Academic Essay',
    description: 'Argument-driven essay for coursework or scholarly publication.',
    icon: 'Feather',
    category: 'academic',
    documentType: 'essay',
    tone: 'analytical',
    targetAudience: 'general_professional',
    approach: 'balanced',
    targetWords: 2500,
  },
  {
    id: 'research-paper',
    title: 'Research Paper',
    description: 'Formal academic paper with abstract, literature review, and discussion.',
    icon: 'GraduationCap',
    category: 'academic',
    documentType: 'research_paper',
    tone: 'authoritative',
    targetAudience: 'industry_peers',
    approach: 'logical',
    targetWords: 5000,
  },
  {
    id: 'literature-review',
    title: 'Literature Review',
    description: 'Synthesize research across sources to map the field.',
    icon: 'Library',
    category: 'academic',
    documentType: 'literature_review',
    tone: 'analytical',
    targetAudience: 'industry_peers',
    approach: 'logical',
    targetWords: 4000,
  },
  {
    id: 'annotated-bibliography',
    title: 'Annotated Bibliography',
    description: 'Sources with formatted citations plus 100-150 word annotations.',
    icon: 'Quote',
    category: 'academic',
    documentType: 'annotated_bibliography',
    tone: 'analytical',
    targetAudience: 'industry_peers',
    approach: 'balanced',
    targetWords: 2000,
    citationStyle: 'apa',
  },
  {
    id: 'bibliography',
    title: 'Bibliography',
    description: 'Properly-formatted citation list, alphabetized by author.',
    icon: 'BookOpen',
    category: 'academic',
    documentType: 'bibliography',
    tone: 'professional',
    targetAudience: 'industry_peers',
    approach: 'balanced',
    targetWords: 500,
    citationStyle: 'apa',
  },
  {
    id: 'thesis-chapter',
    title: 'Thesis Chapter',
    description: 'Single chapter contributing to a larger scholarly argument.',
    icon: 'GraduationCap',
    category: 'academic',
    documentType: 'thesis_chapter',
    tone: 'authoritative',
    targetAudience: 'industry_peers',
    approach: 'logical',
    targetWords: 6000,
  },
];
